<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="sayfaTree"> Sayfa Tree
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="sayfaTanimlama"> Sayfa Tanimlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="sayfaListesi"> Sayfa listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="sayfaCount"> Sayfa count
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="sayfaDurumGuncelle"> Sayfa Durum Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="sayfaDetay"> Sayfa Detay
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="sayfaGuncelle"> Sayfa Güncelle
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import sayfaService from '../../../WSProvider/SayfaService';
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataKader = "";
    export default {
        name: "SayfaDetay",
        methods: {
            sayfaTree() {
                sayfaService.sayfaTree();
            },
            sayfaTanimlama() {
                sayfaService.sayfaTanimlama("", 1, "hakkimizda", "Hakkımızda", "Hakkımızda", "Hakkımızda", "", "",
                    [{
                        "belgeAdi": "belge1",
                        "link": "20200507-j4DF8RF6-belge1.png"
                    }, {
                        "belgeAdi": "belge2",
                        "link": "20200507-df54s5DS-belge2.png"
                    }, {
                        "belgeAdi": "belge3",
                        "link": "20200507-LK5Sa56-belge3.png"
                    }],
                    ["resim1", "resim2", "resim3"], 1, 0, 0, 1);
            },
            sayfaDetay() {
                sayfaService.sayfaDetay("SY-1000");
            },
            sayfaCount() {
                sayfaService.sayfaCount(1);
            },
            sayfaListesi() {
                sayfaService.sayfaListesi(1, 0, 10);
            },
            sayfaDurumGuncelle() {
                sayfaService.sayfaDurumGuncelle("SY-1007", 0);
            },
            sayfaGuncelle() {
                let updateList = [{
                    type: "link",
                    value: "test"
                }, {
                    type: "altBaslik",
                    value: "www.instagram.com"
                }];
                sayfaService.sayfaGuncelle("SY-1000", updateList);
            }
        }
    }
</script>

<style scoped>

</style>